module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"title":"Saulės elektrinė be didelės pradinės investicijos","titleContact":"Susidomėjote? Turite klausimų? Susisiekite!"}}')
  delete Component.options._Ctor
}
